import { Component, ViewChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-dismiss-alert',
  templateUrl: './dismiss-alert.component.html'
})
export class DismissAlertComponent {
  @ViewChild('alert', { static: true }) alert: ElementRef;

  @Input() localeKey: string;
  @Input() localeView: string;
  @Input() alertType: string;
  @Input() closeType: string = '';
  @Input() additionalContent: string = '';

  closeAlert() {
    this.alert.nativeElement.classList.remove('show');
  }

}